import { IResourceLevelingSetting } from '../../interfaces/iresource-leveling-setting';
import { ResourceLevelingPreference } from '../resource-leveling-preference';
import { ResourceType } from '../resource-type';
import { Scenario } from '../scenario';

export class ResourceLevelingSettingBase {
  ResourceLevelingSettingId: number;
  ScenarioId: number;
  LevelingStartDate: Date | null;
  ResourceTypeId: number | null;
  PreferredTravelDistance: number | null;
  LevelByArea: boolean | null;
  MaxNumberAdditionalPerMonth: number | null;
  LevelingPreferenceId: number | null;
  DeadEndPreferenceId: number | null;
  AddResourceMinimumTime: number | null;
  NotifyWhenTotalAvailabilityExceeded: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ResourceType?: ResourceType;
  Scenario?: Scenario;
  ResourceLevelingPreference?: ResourceLevelingPreference;

  constructor(item?: IResourceLevelingSetting) {
    if (item) {

      this.ResourceLevelingSettingId = item.ResourceLevelingSettingId;
      this.ScenarioId = item.ScenarioId;
      this.LevelingStartDate = item.LevelingStartDate ? new Date(item.LevelingStartDate) : null;
      this.ResourceTypeId = item.ResourceTypeId;
      this.PreferredTravelDistance = item.PreferredTravelDistance;
      this.LevelByArea = item.LevelByArea;
      this.MaxNumberAdditionalPerMonth = item.MaxNumberAdditionalPerMonth;
      this.LevelingPreferenceId = item.LevelingPreferenceId;
      this.DeadEndPreferenceId = item.DeadEndPreferenceId;
      this.AddResourceMinimumTime = item.AddResourceMinimumTime;
      this.NotifyWhenTotalAvailabilityExceeded = item.NotifyWhenTotalAvailabilityExceeded;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ResourceType = new ResourceType(item.ResourceType);
      this.Scenario = new Scenario(item.Scenario);
      this.ResourceLevelingPreference = new ResourceLevelingPreference(item.ResourceLevelingPreference);
    }
  }
}